/**
 * @generated SignedSource<<c2cd6fbc5ede9dcf133866ece723f56d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type moduleRatingSummary_Query$variables = {
  nodeRef: string;
};
export type moduleRatingSummary_Query$data = {
  readonly ModuleRating: {
    readonly ModuleRatingNodeSummary: {
      readonly average: number;
      readonly sum: number;
    };
  };
};
export type moduleRatingSummary_Query = {
  response: moduleRatingSummary_Query$data;
  variables: moduleRatingSummary_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "nodeRef"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ModuleRatingQueries",
    "kind": "LinkedField",
    "name": "ModuleRating",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "nodeRef",
            "variableName": "nodeRef"
          }
        ],
        "concreteType": "ModuleRatingNodeSummary",
        "kind": "LinkedField",
        "name": "ModuleRatingNodeSummary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sum",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "average",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "moduleRatingSummary_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "moduleRatingSummary_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8ce8c13675a8ccb19a089d91ac80b4c6",
    "id": null,
    "metadata": {},
    "name": "moduleRatingSummary_Query",
    "operationKind": "query",
    "text": "query moduleRatingSummary_Query(\n  $nodeRef: ID!\n) {\n  ModuleRating {\n    ModuleRatingNodeSummary(nodeRef: $nodeRef) {\n      sum\n      average\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c54e31686e17ba7c63254bd821a5c31e";

export default node;
